module.exports = __webpack_public_path__ + "static/media/logo.612ea285.png";